// pages/FormViewerPage/sections/BumpUpsell.tsx — checkbox produk tambahan fisik
import React from 'react';
import type { BumpOption } from '../../../utils/bumpPricing';

interface Props {
  options: BumpOption[];
  selectedIds: string[];
  onToggle: (id: string) => void;
}

export const BumpUpsell: React.FC<Props> = ({ options, selectedIds, onToggle }) => {
  if (!options.length) return null;
  return (
    <div className="mt-4">
      <h3 className="text-sm font-bold text-slate-900 dark:text-white mb-2">Tambahkan Produk Lain</h3>
      <div className="space-y-3">
        {options.map((opt) => {
          const checked = selectedIds.includes(opt.productId);
          const hemat = Math.max(0, opt.basePrice - opt.addonPrice);
          return (
            <label key={opt.productId} className="flex items-start gap-3 cursor-pointer">
              <input type="checkbox" checked={checked} onChange={() => onToggle(opt.productId)} className="mt-0.5 w-4 h-4 rounded accent-primary" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-900 dark:text-slate-100">{opt.label || opt.name}</p>
                <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                  <span className="text-sm font-bold text-slate-900 dark:text-white tabular-nums">
                    +Rp {opt.addonPrice.toLocaleString('id-ID')}
                  </span>
                  {hemat > 0 && (
                    <span className="text-[10px] font-medium text-emerald-600 dark:text-emerald-400">
                      Hemat Rp {hemat.toLocaleString('id-ID')}
                    </span>
                  )}
                </div>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
};
